import { render } from "./editEstimationLayout.vue?vue&type=template&id=bad5f488&ts=true"
import script from "./editEstimationLayout.vue?vue&type=script&lang=ts"
export * from "./editEstimationLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__